module.exports = __webpack_public_path__ + "img/mobile/General/spelpaus@2x.png?0.0.53";